import { render, staticRenderFns } from "./DocumentCommand.vue?vue&type=template&id=1321b282"
import script from "./DocumentCommand.vue?vue&type=script&setup=true&lang=ts"
export * from "./DocumentCommand.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports